/*
 * @Author: qiaoshiteng
 * @Date: 2023-06-14 11:12:48
 * @LastEditors: qiaoshiteng
 * @LastEditTime: 2023-07-27 09:02:26
 * @Description: 
 */
// @/api/model/user.js

import config from "@/config";
import http from "@/utils/request";

export default {
	userInfo: {
		url: `${config.MAIN_URL}/admin/api/user-msg`,
		name: "获取当前用户信息",
		get: async function () {
			return await http.get(this.url);
		},
	},
	dtilesApi: {
		url: `${config.GAIO_URL}/api/v1/3dtiles`,
		name: "获取当前用户信息",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	list: {
		url: `${config.MAIN_URL}/admin/api/users`,
		name: "获取企业用户列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	showCustom: {
		url: `${config.MAIN_URL}/api/v1/company/showCustom`,
		name: "查询配置数据",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	mailList: {
		url: `${config.MAIN_URL}/api/v1/company/mail/log/data`,
		name: "查询站内信列表",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	loadBalanceList: {
		url: `${config.MAIN_URL}/api/v1/loadBalance`,
		name: "载重平衡单封面列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	mailListsend: {
		url: `${config.MAIN_URL}/api/v1/company/mail/save`,
		name: "保存站内信",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	loadBalancecopy: {
		url: `${config.MAIN_URL}/api/v1/loadBalance/copy`,
		name: "载重平衡单拷贝模版",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	saveloadBalance: {
		url: `${config.MAIN_URL}/api/v1/loadBalance`,
		name: "添加载重平衡单封面",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	loadBalancemb: {
		url: `${config.MAIN_URL}/api/v1/loadBalance/mb`,
		name: "载重平衡单设置模版内容",
		post: async function (params) {
			return await http.post(this.url, params);
		},
		get: async function (params) {
			return await http.get(this.url + params);
		},
	},
	mailListdata: {
		url: `${config.MAIN_URL}/api/v1/company/mail/data`,
		name: "查询站内信列表",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	loadBalanceModel: {
		url: `${config.MAIN_URL}/api/v1/user/loadBalance`,
		name: "载重平衡单",
		get: async function (params) {
			return await http.get(this.url + params);
		},
	},
	deletesend: {
		url: `${config.MAIN_URL}/api/v1/company/mail/delete`,
		name: '删除站内信',
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},
	statusupdate: {
		url: `${config.MAIN_URL}/api/v1/company/mail/log/update`,
		name: "查询站内信列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	delete: {
		url: `${config.MAIN_URL}/api/v1/company/mail/log/delete`,
		name: '删除站内信',
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},
	change: {
		url: `${config.MAIN_URL}/admin/api/change-user`,
		name: "修改状态",
		put: async function (params) {
			return await http.put(this.url + params);
		},
	},
	loadBalanceEdit: {
		url: `${config.MAIN_URL}/api/v1/loadBalance`,
		name: "修改载重平衡单",
		put: async function (params) {
			return await http.put(this.url, params);
		},
		delete: async function (params) {
			return await http.delete(this.url + params);
		},

	},
	names: {
		url: `${config.MAIN_URL}/user/v1/names`,
		name: "获取所有的用户名",
		get: async function (params) {
			return await http.get(this.url + params);
		},
	}

};
